import React, { useContext } from 'react'
import Header from './Header'
import Sidebar from './Sidebar'
import Footer from './Footer'
import { Settings } from '../contexts/Settings'

function Main({ children }) {
    const { clickOverlay, overlay } = useContext(Settings);
    return (
        <>
            <div className="page">
                <Header />
                <Sidebar />
                <div className="main-content app-content">
                    <div className="container-fluid">

                        {children}
                    </div>
                </div>
                <Footer />
                <div id="responsive-overlay" class={overlay ? "active" : ""} onClick={clickOverlay}></div>
            </div>
        </>
    )
}

export default Main